module.exports = __webpack_public_path__ + "static/media/MU.bbd0a2df.svg";